module.exports = __webpack_public_path__ + "img/icon-we-own-locations@2x.288673e4.png";